module.exports = __webpack_public_path__ + "static/media/parallax06.9281c121.svg";